import { useContext } from "react";
import { MapUserContext } from "../contexts/MapUserContext";

const useMapUser = () => {
  const context = useContext(MapUserContext);
  if (!context) {
    throw new Error("useMapUser must be used within a MapUserProvider");
  }
  return context;
};

export default useMapUser;
